// Global function to apply dark or light mode
function applySystemTheme() {
    const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  
    if (prefersDarkMode) {
      document.documentElement.classList.remove('lightmode');
      document.documentElement.classList.add('darkmode');
    } else {
      document.documentElement.classList.remove('darkmode');
      document.documentElement.classList.add('lightmode');
    }
  }
  
  // Listen for changes in the system's dark/light mode preference
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', applySystemTheme);
  
  // Run on initial load
  applySystemTheme();